<template>
  <b-modal
    v-model="isVisible"
    centered
    title-class="h4 align-self-center"
    body-class="py-0"
    :title="title"
    :ok-title="confirmText"
    :cancel-title="cancelText"
    :ok-variant="confirmVariant"
    :cancel-variant="cancelVariant"
    @ok="confirm"
    @cancel="cancel"
    @hide="handleHide"
  >
    <slot>
      <p class="text-body" v-html="message" />
    </slot>
  </b-modal>
</template>

<script>
import { noop } from "@/helpers/functions/FunctionHelpers";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "Prompt",
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "Confirmar",
    },
    cancelText: {
      type: String,
      default: "Cancelar",
    },
    confirmVariant: {
      type: String,
      default: "exitos",
    },
    cancelVariant: {
      type: String,
      default: "secondary",
    },
  },
  setup() {
    const isVisible = ref(false);
    let resolveResult = noop;

    function open(resolve) {
      resolveResult = resolve;
      isVisible.value = true;
    }

    function finish(value) {
      resolveResult(value);
      resolveResult = noop;
      isVisible.value = false;
    }

    function confirm() {
      finish(true);
    }

    function cancel() {
      finish(false);
    }

    function close() {
      cancel();
    }

    function handleHide() {
      cancel();
    }

    return {
      isVisible,
      open,
      close,
      confirm,
      cancel,
      handleHide,
    };
  },
});
</script>
